"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstAccount = exports.getUpcomingState = exports.getHeaderData = exports.getBalanceData = exports.getDisplayColumnsKey = exports.hasBlockedLoanAccount = exports.makeLocationObject = void 0;
const query_string_1 = __importDefault(require("query-string"));
const luxon_1 = require("luxon");
const accounts_1 = require("companion-app-components/flux/accounts");
const types_1 = require("data/accountBalances/types");
const defaults_1 = require("data/preferences/defaults");
const makeLocationObject = (location) => {
    const query = query_string_1.default.parse(location.search);
    const nodeId = query.displayNode ? query.displayNode : 'all';
    const txnId = query.txnId ? query.txnId : null;
    const showCalendarUI = (query === null || query === void 0 ? void 0 : query.displayMode) === 'calendar';
    return Object.assign({ selectedAccountNodeId: nodeId, location, firstTxnId: txnId }, (showCalendarUI || txnId !== null ? { showCalendarUI } : {}));
};
exports.makeLocationObject = makeLocationObject;
const hasBlockedLoanAccount = (accountNode, accountsById, hideLoanTransactions, hideConnectedLoanTransactions) => {
    const firstAccount = accountsById.get(accountNode.allAccountIds.first());
    // @ts-expect-error: An argument for 'state' was not provided.
    return (firstAccount === null || firstAccount === void 0 ? void 0 : firstAccount.type) === 'LOAN' && accounts_1.accountsUtils.transactionsNotSupportedForAccountId(accountNode.id, hideLoanTransactions, hideConnectedLoanTransactions);
};
exports.hasBlockedLoanAccount = hasBlockedLoanAccount;
const getDisplayColumnsKey = (accountNode, regFieldsSort) => {
    const isLeaf = accountNode && !accountNode.children;
    return isLeaf
        ? (0, defaults_1.regFieldsSortType)(regFieldsSort, accountNode.account.type)
        : (accountNode && (0, defaults_1.regFieldsSortType)(regFieldsSort, accountNode.id)) || 'cashFlow';
};
exports.getDisplayColumnsKey = getDisplayColumnsKey;
const getBalanceData = (accountNode, balanceKey) => {
    const balanceRecord = types_1.visibleBalances.find((visibleBalance) => visibleBalance.value === balanceKey);
    const balanceText = balanceRecord ? balanceRecord.label : balanceKey;
    let balance = 'loading...';
    if (accountNode) {
        balance = balanceRecord ? accountNode[balanceRecord.key] : accountNode.sumEndingAccountBalances;
    }
    return {
        balance,
        balanceRecord,
        balanceText,
    };
};
exports.getBalanceData = getBalanceData;
const getHeaderData = (accountNode, isLeaf, accountsById, hideLoanTransactions, hideConnectedLoanTransactions) => {
    let isLoanPage = false;
    let title = 'Transactions List';
    let subtitle = '';
    if (accountNode) {
        title = accountNode.displayLabel;
        if (accountNode.earliestTransactionDate) {
            subtitle = `Earliest Transaction Date: ${luxon_1.DateTime.fromISO(accountNode.earliestTransactionDate).toFormat('MM/dd/yyyy')}`;
        }
        isLoanPage = isLeaf && (0, exports.hasBlockedLoanAccount)(accountNode, accountsById, hideLoanTransactions, hideConnectedLoanTransactions);
    }
    return {
        isEditableTitle: !!(accountNode && !accountNode.children),
        isLoanPage,
        subtitle,
        title,
    };
};
exports.getHeaderData = getHeaderData;
const getUpcomingState = (projectedBalances, accountNode, calendarList) => {
    let showUpcoming = projectedBalances && accountNode;
    let showGraph = false;
    if (showUpcoming) {
        showGraph = accountNode.allAccountIds.size === 1;
        showUpcoming = calendarList || showGraph;
    }
    return {
        showGraph,
        showUpcoming,
    };
};
exports.getUpcomingState = getUpcomingState;
const getFirstAccount = (accountNode, accountsById) => ((accountNode === null || accountNode === void 0 ? void 0 : accountNode.account) || accountsById.get(accountNode === null || accountNode === void 0 ? void 0 : accountNode.allAccountIds.first()) || accountsById.first());
exports.getFirstAccount = getFirstAccount;
